// extracted by mini-css-extract-plugin
var _1 = "ProfileContractsTabInhabitant-moduleContractsTabMock__XdMjJ";
var _2 = "ProfileContractsTabInhabitant-moduleactions__bqAsI";
var _3 = "ProfileContractsTabInhabitant-moduletoolbar__WOgk0";
export { _1 as "ContractsTabMock", _2 as "actions", _3 as "toolbar" }
